// extracted by mini-css-extract-plugin
export var categoryCards = "CategorySpecificSection-module--category-cards--2xlaK";
export var primary = "#06004d";
export var secondary = "#4dafd7";